import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.546 4.536c1.367-1.163 3.498-1.587 5.379-.857.786.305 1.42.94 1.725 1.726.73 1.881.306 4.013-.858 5.38-1.392 1.634-2.209 2.426-3.033 3.125l2.034 8.89c.29 1.27-.034 2.611-.969 3.546l-1.401 1.401a1.333 1.333 0 0 1-2.157-.391l-3.812-8.397-3.584 3.136.495 1.325c.523 1.401.273 3-.808 4.08l-1.443 1.443a1.333 1.333 0 0 1-2.117-.312L8.41 23.81l-4.908-2.67a1.333 1.333 0 0 1-.305-2.114l1.431-1.431c1.09-1.09 2.707-1.335 4.115-.796l-.477 1.245.477-1.245 1.821.698 2.877-3.59-8.468-3.844a1.333 1.333 0 0 1-.392-2.157l1.401-1.402c.935-.935 2.277-1.259 3.546-.968l8.887 2.033c.7-.829 1.49-1.643 3.13-3.034m4.414 1.629c-.962-.373-2.061-.13-2.687.403l-.002.001c-1.925 1.634-2.527 2.347-3.308 3.32-.32.398-.839.578-1.337.464L8.934 8.136c-.458-.105-.838.028-1.065.255l-.04.04 8.277 3.757a1.333 1.333 0 0 1 .49 2.048l-4.558 5.689a1.33 1.33 0 0 1-1.518.411l-2.73-1.045c-.542-.208-1.014-.071-1.275.19l-.17.17 3.69 2.008c.228.124.415.312.537.54l1.926 3.59.173-.174c.26-.26.397-.725.196-1.263l-.817-2.188a1.33 1.33 0 0 1 .371-1.47l5.628-4.923a1.333 1.333 0 0 1 2.092.452l3.757 8.278.04-.04c.228-.228.36-.607.255-1.066l-2.217-9.692a1.33 1.33 0 0 1 .46-1.334c.969-.783 1.691-1.394 3.326-3.313.533-.626.776-1.725.402-2.686a.38.38 0 0 0-.204-.205",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }